import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";

export default function Impressum() {
  usePageMeta({
    title: "Impressum – Pirate Bowling Center Velburg",
    description: "Impressum des Pirate Bowling Center Velburg. Anbieterkennzeichnung gemäß § 5 TMG.",
    noindex: true,
  });
  return (
    <div className="min-h-screen bg-navy text-cream">
      {/* Top bar */}
      <div className="border-b border-gold/10 bg-navy-deep/80 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-cream-muted hover:text-gold transition-colors text-sm font-space-grotesk"
            data-testid="back-home-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <span className="font-unbounded text-xs font-bold gold-text tracking-widest uppercase">
            Pirate Bowling Center
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="mb-12">
          <div className="skull-divider mb-6">
            <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">Rechtliches</span>
          </div>
          <h1
            className="font-unbounded text-4xl md:text-5xl font-black text-cream"
            data-testid="impressum-headline"
          >
            Impressum
          </h1>
        </div>

        <div className="glass border border-gold/10 rounded-2xl p-8 md:p-10 space-y-8 font-inter text-cream/80 leading-relaxed">
          <section data-testid="impressum-company">
            <h2 className="font-unbounded text-lg font-bold text-cream mb-4">Langebach GbR</h2>
            <p>
              Pirate Bowling Center<br />
              Hainstraße 4<br />
              92355 Velburg
            </p>
          </section>

          <div className="w-full h-px bg-gradient-to-r from-gold/20 to-transparent" />

          <section data-testid="impressum-contact">
            <h2 className="font-unbounded text-base font-bold text-cream mb-4">Vertreten durch</h2>
            <p>Ralf Langebach, Angelika Langebach</p>
          </section>

          <div className="w-full h-px bg-gradient-to-r from-gold/20 to-transparent" />

          <section data-testid="impressum-details">
            <h2 className="font-unbounded text-base font-bold text-cream mb-4">Kontakt</h2>
            <p className="space-y-1">
              <span className="block">
                E-Mail:{" "}
                <a href="mailto:info@pirate-bowling.com" className="text-gold hover:text-gold-light transition-colors">
                  info@pirate-bowling.com
                </a>
              </span>
              <span className="block">
                Tel.:{" "}
                <a href="tel:+499182938936" className="text-gold hover:text-gold-light transition-colors">
                  09182 / 938936
                </a>
              </span>
            </p>
          </section>

          <div className="w-full h-px bg-gradient-to-r from-gold/20 to-transparent" />

          <section data-testid="impressum-odr">
            <h2 className="font-unbounded text-base font-bold text-cream mb-4">Online-Streitbeilegung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter{" "}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-gold-light transition-colors"
              >
                https://ec.europa.eu/consumers/odr
              </a>{" "}
              finden. Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <div className="w-full h-px bg-gradient-to-r from-gold/20 to-transparent" />

          <section data-testid="impressum-vsbg">
            <h2 className="font-unbounded text-base font-bold text-cream mb-4">Verbraucherstreitbeilegung</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </div>

      <LegalFooter />
    </div>
  );
}

export function LegalFooter() {
  return (
    <footer className="border-t border-gold/8 py-8 px-6">
      <div className="max-w-3xl mx-auto flex flex-wrap justify-center gap-6 text-xs text-cream/25 font-space-grotesk">
        <Link to="/impressum" className="hover:text-gold transition-colors">Impressum</Link>
        <Link to="/datenschutz" className="hover:text-gold transition-colors">Datenschutz</Link>
        <Link to="/agb" className="hover:text-gold transition-colors">AGBs</Link>
        <span>&copy; {new Date().getFullYear()} Pirate Bowling Center Velburg</span>
      </div>
    </footer>
  );
}
